import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield, Lock } from 'lucide-react';

const ReferralTrust = () => {
  const { t } = useTranslation();
  return (
    <section aria-label="Trust and Security">
      <h2 className="sr-only">Trust &amp; Security</h2>
      <div className="flex items-center justify-center gap-4 text-sm text-muted-foreground border border-green-600/20 bg-green-50/50 dark:bg-green-950/20 rounded-lg px-4 py-2">
        <div className="flex items-center gap-1.5">
          <Shield className="h-4 w-4 text-green-600" aria-hidden="true" />
          <span className="font-medium">{t('referral.landing.trustPipeda')}</span>
        </div>
        <div className="flex items-center gap-1.5">
          <Lock className="h-4 w-4 text-green-600" aria-hidden="true" />
          <span className="font-medium">{t('referral.landing.trustEncrypted')}</span>
        </div>
      </div>
    </section>
  );
};

export default ReferralTrust;
